import { FieldIdentifier as AddressFieldIdentifier } from '@banking/ui/models/common/address';
export let BusinessFieldIdentifier = /*#__PURE__*/function (BusinessFieldIdentifier) {
  BusinessFieldIdentifier["BUSINESS_NAME"] = "BUSINESS_NAME";
  BusinessFieldIdentifier["EIN"] = "EIN";
  BusinessFieldIdentifier["CONFIRM_EIN"] = "CONFIRM_EIN";
  return BusinessFieldIdentifier;
}({});
export function assertsIsFieldIdentifier(val) {
  if (!(val in BusinessFieldIdentifier) && !(val in AddressFieldIdentifier)) {
    throw new Error('Value is not member of FieldIdentitifer');
  }
}